import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "burger-icon"
}
const _hoisted_2 = { class: "new-chat-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Burger = _resolveComponent("Burger")
  const _component_ChatInputV2 = _resolveComponent("ChatInputV2")
  const _component_CommandsShortcuts = _resolveComponent("CommandsShortcuts")

  return (_openBlock(), _createElementBlock("main", {
    id: "chat",
    ref: "page",
    class: _normalizeClass(["new-chat", {creating: $data.creating}])
  }, [
    (_ctx.$responsive.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Burger)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Where should we start?", -1 /* HOISTED */)),
      _createVNode(_component_ChatInputV2, {
        ref: "input",
        modelValue: $data.input_text,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.input_text) = $event)),
        class: "chat-input",
        expanded: $data.expanded && _ctx.$responsive.desktop,
        controls: _ctx.$responsive.desktop,
        description: "Genrate can make mistakes. Consider checking important information.",
        placeholder: _ctx.$responsive.mobile ? 'Ask anything...' : 'Ask anything, or type / to run a skill…',
        onCapsLoaded: _cache[1] || (_cache[1] = $event => ($data.caps = $event)),
        onRegenerate: $options.onChat
      }, null, 8 /* PROPS */, ["modelValue", "expanded", "controls", "placeholder", "onRegenerate"]),
      (_ctx.$responsive.desktop && $data.caps)
        ? (_openBlock(), _createBlock(_component_CommandsShortcuts, {
            key: 0,
            class: "welcome-actions",
            skills: $data.caps.skills,
            onSkill: _cache[2] || (_cache[2] = $event => (_ctx.$refs.input.setCommand($event)))
          }, null, 8 /* PROPS */, ["skills"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}